const Privacy = () => {
    return (
        <div className="privacy">
            <h1>
                Privacy Policy
            </h1>
            <p>
                The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the legal data protection regulations (EU-Geral Data Protection Regulation „GDPR“) as well as this data protection declaration.
                
            </p>
            <p>
                The use of our website is generally possible without providing personal data; apart from the collection of data for the provision of the website (the storage of the data in logfiles is mandatory for the operation of the website). Insofar as personal data (e. g. name, address or e-mail addresses or other data) are collected on our pages, this is always done on a voluntary basis as far as possible. These data will not be passed on to third parties without your express consent.
                
            </p>
            <p>
                In the following, we will tell you what data is collected during your visit to our website, as well as the legal basis for the processing of personal data, the purpose of the data processing and how it is used, the duration of the storage and your rights in this context.
                
            </p>
            <p>
                <b>I. General information on data processing</b>
                
            </p>
            <p>
                <b>1. Scope of the processing of personal data</b>
                
            </p>
            <p>
                We collect and use the personal data of our users only insofar as this is necessary for the provision of a functional website as well as our content and services. The collection and use of our users' personal data is regularly only carried out with the user's consent. An exception shall apply in cases where prior consent cannot be obtained for factual reasons and where the processing of data is permitted by legal regulations.
                
            </p>
            <p>
                <b>2. Legal basis for the processing of personal data</b>
                
            </p>
            <p>
                Insofar as we obtain the consent of the data subject for the processing of personal data, Art. 6 (1)(a) of the EU General Data Protection Regulation (GDPR) serves as the legal basis for the processing of personal data.
                
            </p>
            <p>
                Article 6 (1)(b) of the GDPR serves as the legal basis for the processing of personal data required for the performance of a contract to which the data subject is a party. This shall also apply to processing operations necessary for the implementation of pre-contractual measures.
                
            </p>
            <p>
                Insofar as a processing of personal data is necessary for the fulfilment of a legal obligation to which our company is subject, Art. 6 para. 1 lit. c GDPR serves as a legal basis.
                
            </p>
            <p>
                In the event that the vital interests of the data subject or another natural person necessitate the processing of personal data, Art. 6 (1)(d) GDPR serves as the legal basis.
                
            </p>
            <p>
                If the processing is necessary to safeguard a legitimate interest of our company or a third party and if the interests, fundamental rights and freedoms of the party concerned do not outweigh the first mentioned interest, Art. 6 para. 1 lit. f GDPR serves as the legal basis for the processing.
                
            </p>
            <p>
                <b>Data erasure and storage duration</b>
                
            </p>
            <p>
                The personal data of the person concerned will be deleted or blocked as soon as the purpose of the storage no longer applies. In addition, data may also be stored if the European or national legislature has provided for this in Union regulations, laws or other provisions to which the person responsible is subject. Data will also be blocked or deleted if a storage period prescribed by the aforementioned standards expires, unless there is a requirement for further storage of data for the conclusion of a contract or fulfilment of a contract.
                
            </p>
            <p><b>II. Provision of the website and creation of logfiles</b></p>
<p>            </p>
            <p>
                The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:
                
            </p>
            <ul>
                
                    	<li>browser type and browser version</li>
                    	<li>operating system used</li>
                    	<li>the internet service provider of the user</li>
                    	<li>the IP address of the user</li>
                    	<li>hostname of the accessing computer</li>
                    	<li>time of the server inquiry</li>
                    	<li>websites from which the user's system reaches our website</li>
                    	<li>websites accessed by the user's system via our website</li>
                
            </ul>
            <p>
                The data is also stored in the log files of our system. These data are not stored together with other personal data of the user and is not combined with other data sources. We reserve the right to check this data at a later date if we become aware of specific indications of illegal use.
                
            </p>
            <p>
                The legal basis for the temporary storage of data and log files is Art. 6 para. 1 lit. f GDPR.
                
            </p>
            <p>
                The temporary storage of the IP address by the system is necessary to enable the website to be delivered to the user's computer. The storage in logfiles is done to ensure the functionality of the website. In addition, the data is used to optimize the website and to ensure the security of our information technology systems. An evaluation of the data for marketing purposes does not take place in this context. For this purpose, the user's IP address must be stored for the duration of the session. Our legitimate interest in data processing pursuant to Art. 6 para. 1 lit. f of the GDPR also lies in these purposes.
                
            </p>
            <p>
                The data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected. In the case of the collection of data for the provision of the website, this is the case when the respective session has ended. The storage of data in logfiles will be done after seven days at the latest. Additional storage is possible. In this case, the IP addresses of the users are deleted or changed, so that an assignment of the calling client is no longer possible.
                
            </p>
            <p>
                The collection of data for the provision of the website and the storage of the data in logfiles is mandatory for the operation of the website. Consequently, there is no possibility of objection on the part of the user.
                
            </p>
            <b>III. Newsletter data</b>
            
            <p>
                You can subscribe to a free newsletter on our website. When registering for the newsletter, the data from the input mask will be transmitted to us. In addition, the following data is collected during registration:
                
            </p>
                <ul>
                    	<li>email address of the user</li>
                    	<li>IP address of the calling computer/ user</li>
                    	<li>date and time of registration</li>
                </ul>
            
            <p>
                If you would like to receive the newsletter offered on the website, we need an email address from you. The registration for our newsletter is done in a so-called double opt-in procedure (DOI). After your registration you will receive an email to the email address you have given us, where you will be asked to confirm your registration. This confirmation is required so that no unauthorized third party can register with your email address.
                
            </p>
            <p>
                No data is passed on to third parties in connection with data processing for sending newsletters. The data will only be used for sending the newsletter.
                
            </p>
            <p>
                The legal basis for the processing of the data after registration for the newsletter by the user is Art. 6 para. 1 lit. a DSGVO on the basis of the corresponding consent. The collection of the user's e-mail address serves to send the newsletter.
                
            </p>
            <p>
                The registration for the newsletter is logged in order to prove the registration process. This includes the storage of the registration and confirmation time as well as the IP address. This data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected. The data will be saved as long as the subscription to the newsletter is active.
                
            </p>
            <p>
                You can revoke your consent to the storage of the data, the email address and its use for sending the newsletter at any time, for example via the "unsubscribe"link in the newsletter.
                
            </p>
            <p>
                <b>Registration on our website</b>
                
            </p>
            <p>On our website, we offer users the opportunity to register by providing personal data. The data is entered into an input mask and transmitted to us and stored. The data will not be passed on to third parties. As part of the registration process, the user's consent to the processing of this data is obtained. The following data is collected during the registration process:</p>
<ul>
    
        	<li>email address</li>
        	<li>password</li>
        	<li>date of birth</li>
</ul>
            
            <p>
                The following data is also stored at the time of registration:
                
            </p>
                <ul>
                    	<li>IP address of the calling computer/ user</li>
                    	<li>date and time of registration</li>
                </ul>
            
            <p>
                The legal basis for the processing of the data after registration on our website by the user is Art. 6 para. 1 lit. b GDPR on the basis of the corresponding consent.
                
            </p>
            <p>
                A registration of the user is necessary to carry out pre-contractual measures and to conclude and execute the contract.
                
            </p>
            <p>
                The data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected. Even after conclusion of the contract, it may be necessary to store personal data of the contractual partner in order to fulfil contractual or legal obligations.
                
            </p>
            <p>
                As a user you have the possibility to cancel the registration at any time. You can have the data stored about you changed at any time. If the data are necessary for the fulfilment of a contract or for the execution of pre-contractual measures, a premature deletion of the data is only possible if there are no contractual or legal obligations to prevent a deletion.
                
            </p>
            <p>
                <b>Contact form and email contact</b>
                
            </p>
            <p>
                A contact form is available on our website, which can be used for electronic contact. If a user chooses this option, the data entered in the input mask will be transmitted to us and stored. In addition, the following data are stored at the time of sending the message:
                
            </p>
                <ul>
                    	<li>the IP address of the calling computer/ user</li>
                    	<li>date and time of the registration</li>
                </ul>
            
            <p>
                For the processing of the data, your consent will be obtained and referred to this data protection declaration.
                
            </p>
            <p>
                Alternatively, it is possible to contact us via the provided email address. In this case, the personal data of the user transmitted by email will be stored. In this context, the data will not be passed on to third parties. The data will only be used for the processing of the conversation.
                
            </p>
            <p>
                The legal basis for the processing of data is Art. 6 para. 1 lit. a GDPR, if the user gives his/her consent. The legal basis for the processing of data transmitted by email is Art. 6 para. 1 lit. f GDPR.
                
            </p>
            <p>
                The processing of personal data from the input mask serves us solely for the purpose of processing the contact. If you contact us by email, this is also the reason for the necessary legitimate interest in processing the data. The other personal data processed during the sending process is used to prevent misuse of the contact form and to ensure the security of our information technology systems.
                
            </p>
            <p>
                The data will be deleted as soon as it is no longer necessary to achieve the purpose for which it was collected. For personal data from the input mask of the contact form and those sent by email, this is the case when the respective conversation with the user has ended. The conversation ends when the circumstances indicate that the matter in question has been conclusively clarified. The additional personal data collected during the sending process will be deleted after a period of seven days at the latest.
                
            </p>
            <p>
                The user has the possibility to revoke his or her consent to the processing of personal data at any time. If the user contacts us by email, he can object to the storage of his personal data at any time. In such a case, the conversation cannot continue.
                
            </p>
            <p>
                In this case, all personal data stored in the course of making contact will be deleted.
                
            </p>
            <p>
                <b>NOTES ON EMAIL COMMUNICATION</b>
                
            </p>
            <p>
                We will of course make every effort to store your personal data in such a way that they are not accessible to third parties by using all technical and organisational means. However, full data security cannot be guaranteed when communicating by email, so we recommend that you send confidential information by post.
                
            </p>
            <p>
                <b>NOTES ON SSL ENCRYPTION</b>
                
            </p>
            <p>
                This site uses SSL encryption for security reasons and to protect the transmission of confidential content, such as requests you send to us as the site operator. An encrypted connection can be recognized by the fact that the address line of the browser changes from "http://" to "https://" and the lock symbol in your browser line.
                
            </p>
            <p>
                If SSL encryption is enabled, the information you provide to us cannot be read by third parties.
                
            </p>
            <p>
                <b>Rights of the person concerned</b>
                
            </p>
            <p>
                Every user of our website has the right to demand information at any time about which data is stored about him or her and for what purpose this storage takes place. In addition, a correction of incorrect data or the deletion of data whose storage is inadmissible or no longer necessary may be demanded.
                
            </p>
            <p>
                <b>
                    UPON WRITTEN REQUEST, WE WILL BE PLEASED TO INFORM YOU ABOUT THE PERSONAL DATA STORED ON YOUR PERSON AND OF COURSE WE WILL ALSO COMPLY WITH YOUR FURTHER ASSERTED CLAIMS.
                
                </b>
            </p>
            <p>
                If personal data is processed by you, you are affected within the meaning of the GDPR and you have the following rights vis-à-vis the person responsible:
                
            </p>
            <p>
                <b>1. Right to information</b>
                
            </p>
            <p>
                You can ask the person in charge to confirm whether we process personal data concerning you. In the event of such processing, you may request the following information from the person responsible:
                
            </p>
                <ul>
                    	<li>(1) the purposes for which the personal data are processed;</li>
                    	<li>(2) the categories of personal data which are processed;</li>
                    	<li>(3) the recipients or categories of recipients to whom the personal data concerning you have been or will be disclosed;</li>
                    	<li>(4) the planned duration of the storage of personal data concerning you or, if specific information is not possible, criteria for determining the storage duration;</li>
                    <li>(5) the existence of a right to correct or delete personal data concerning you, a right to restrict the processing by the controller or a right of objection to such processing;</li>
                    	<li>(6) the existence of a right of appeal to a supervisory authority;</li>
                    	<li>(7) all available information on the origin of the data if the personal data are not collected from the data subject;</li>
                    	<li>(8) the existence of automated decision-making, including profiling in accordance with Article 22 (1) and (4) of the GDPR and, at least in these cases, meaningful information on the logic involved and the scope and intended impact of such processing on the data subject.</li>
                </ul>
            
            <p>
                You have the right to request information on whether the personal data concerning you are transferred to a third country or to an international organisation. In this context, you may request to be informed of the appropriate guarantees pursuant to Art. 46 GDPR in connection with the transmission.
                
            </p>
            <p>
                <b>2. Right of rectification</b>
                
            </p>
            <p>
                You have the right to correct and/or complete your personal data with regard to the person in charge if the personal data processed concerning you is incorrect or incomplete. The person responsible must make the correction without delay.
                
            </p>
            <p>
                <b>3. Right to restrict processing</b>
                
            </p>
            <p>
                Under the following conditions, you may request that the processing of your personal data be restricted:
                
            </p>
                	<ul>
                        <li>(1) if you deny the accuracy of the personal data relating to you for a period of time that enables the person responsible to verify the accuracy of the personal data;</li>
                        <li>(2) the processing is unlawful and you refuse to delete the personal data and instead request the restriction of the use of the personal data;</li>
                        <li>(3) the controller no longer needs the personal data for the purposes of processing, but you need them to assert, exercise or defend legal claims; or</li>
                        <li>(4) if you have lodged an objection against the processing pursuant to Art. 21 para. 1 GDPR and it has not yet been determined whether the legitimate reasons of the person responsible outweigh your grounds.</li>
                    </ul>        
            <p>
                Where the processing of personal data relating to you has been restricted, such data may not be processed except with your consent or for the purpose of asserting, exercising or defending legal claims or protecting the rights of another natural or legal person, or for reasons of an important public interest of the Union or of a Member State, except for their storage.
                
            </p>
            <p>
                If the restriction on processing has been restricted in accordance with the above-mentioned conditions, you will be informed by the person responsible before the restriction is lifted.
                
            </p>
            <p>
                <b>4. Right of deletion</b><br/>
                <b>a) Obligation to delete</b>
                
            </p>
            <p>
                You may demand that the person in charge of your personal data be deleted immediately and the person in charge is obliged to delete this data immediately if one of the following reasons applies:
                
            </p>
                	<ul>
                        <li>(1) The personal data concerning you are no longer necessary for the purposes for which they were collected or otherwise processed.</li>
                        <li>(2) You revoke your consent to the processing in accordance with Art. 6 Para. 1 lit. a or Art. 9 Para. 2 lit. a GDPR and there is no other legal basis for the processing.</li>
                        <li>(3) In accordance with Art. 21 para. 1 of the GDPR, you submit an objection to the processing and there are no primordial justifiable reasons for the processing or you lodge an objection against the processing pursuant to Art. 21 para. 2 of the GDPR.</li>
                        <li>(4) The personal data concerning you have been processed illegally.</li>
                        <li>(5) The deletion of personal data concerning you is necessary to fulfil a legal obligation under Union law or the law of the Member States to which the data controller is subject.</li>
                        <li>(6) The personal data concerning you have been collected in relation to the information society services offered in accordance with Article 8 (1) of the GDPR.</li>
                    </ul>
            <p>
                <b>b) Information to third parties</b>
                
            </p>
            <p>If the person in charge has made the personal data concerning you public and if he is obliged to delete them in accordance with Art. 17 para. 1 of the GDPR, he shall take appropriate measures, taking into account the available technology and the implementation costs, including technical measures, to inform those responsible for data processing who process the personal data that you, as the person concerned, have requested that they delete all links to these personal data or from copies or replicas of these personal data.</p>
            <p>
                <b>
                
                    c) Exceptions
                </b>
            </p>
            
            <p>
                The right to be deleted does not exist if the processing is necessary.
                
            </p>
                	<ul>
                        <li>(1) the exercise of the right to freedom of expression and information;</li>
                        <li>(2) in order to fulfil a legal obligation requiring processing under Union or national law to which the person responsible is subject, or to carry out a task which is in the public interest or in the exercise of official authority delegated to the person responsible;</li>
                        <li>(3) for reasons of public interest in the field of public health in accordance with Art. 9 (2)(h) and (i) and Art. 9 (3) GDPR;</li>
                        <li>(4) for archival purposes in the public interest, scientific or historical research or for statistical purposes in accordance with Art. 89 (1) GDPR, insofar as the right referred to in (a) above is likely to make it impossible or seriously prejudice the achievement of the objectives of such processing; or</li>
                        <li>(5) for asserting, exercising or defending legal claims.</li>
                    </ul>
            <p>
                <b>5. Right to be informed</b>
                
            </p>
            <p>
                If you have asserted the right to correct, delete or restrict the processing of your personal data, the controller is obliged to inform all recipients to whom the personal data concerning you have been disclosed of this correction or deletion of the data or limitation of the processing, unless this proves to be impossible or involves a disproportionate effort.
                
            </p>
            <p>
                You have the right to be informed of these recipients vis-à-vis the person responsible.
                
            </p>
            <p>
                <b>6. Right to transfer data</b>
                
            </p>
            <p>
                You have the right to obtain the personal data relating to you that you have provided to the data controller in a structured, current and machine-readable format. In addition, you have the right to transfer this data to another responsible person without hindrance by the person to whom the personal data has been made available, provided that
                
            </p>
                	<ul>
                        <li>(1) the processing is based on a consent pursuant to Art. 6 para. 1 lit. a GDPR or Art. 9 para. 2 lit. a GDPR or on a contract pursuant to Art. 6 para. 1 lit. b GDPR and</li>
                        <li>(2) processing shall be carried out by means of automated procedures.</li>
                    </ul>
            <p>
                In exercising this right, you also have the right to obtain that the personal data concerning you are transmitted directly by one person in charge to another person in charge, as far as this is technically feasible. Freedoms and rights of other persons may not be affected thereby.
                
            </p>
            <p>
                The right to transfer data shall not apply to the processing of personal data necessary for the performance of a task which is in the public interest or in the exercise of official authority delegated to the data controller.
                
            </p>
            <p><b>7. Right of objection</b></p>

                            
                <p>
                    For reasons arising from your particular situation, you have the right to object at any time to the processing of personal data concerning you, which is carried out on the basis of Art. 6 para. 1 lit. e or f of the GDPR; this also applies to profiling based on these provisions.
                    
                </p>
                
                <p>
                    The controller will no longer process the personal data concerning you, unless he can prove that there are compelling grounds worthy of protection for the processing that outweigh your interests, rights and freedoms, or the processing serves to assert, exercise or defend legal claims.
                    
                </p>
                <p>
                    If the personal data concerning you are processed in order to carry out direct advertising, you have the right to object at any time to the processing of personal data concerning you for the purpose of such advertising; this also applies to profiling, insofar as it is associated with such direct advertising.
                    
                </p>
                <p>
                    If you object to the processing for the purposes of direct marketing, the personal data concerning you will no longer be processed for these purposes.
                    
                </p>
                <p>
                    You have the possibility of exercising your right of objection to the use of information society services, without prejudice to Directive 2002/58/EC, by means of automated procedures using technical specifications.
                    
                </p>
                <p><b>8. Right to revoke the declaration of consent under data protection law</b></p>
                
                <p>
                    You have the right to revoke your declaration of consent under data protection law at any time. The revocation of the consent does not affect the legality of the processing carried out on the basis of the consent until the revocation.
                    
                </p>
                
                <p><b>9. Automated decision in individual cases including profiling</b></p>
                
                <p>
                    You have the right not to be subject to a decision based solely on automated processing - including profiling - which has legal effect on you or which significantly impairs you in a similar manner. This does not apply if the decision
                    
                </p>
                    	<ul>
                            <li>(1) is necessary for the conclusion or performance of a contract between you and the person responsible,</li>
                            <li>(2) that the legislation of the Union or of the Member States to which the person responsible is subject is admissible and that such legislation contains appropriate measures to protect your rights and freedoms and your legitimate interests; or</li>
                            <li>(3) with your express consent.</li>
                        </ul>
                
                <p>
                    However, these decisions may not be based on special categories of personal data in accordance with Art. 9 para. 1 GDPR, unless Art. 9 para. 2 letter a or g applies and appropriate measures have been taken to protect the rights and freedoms as well as your legitimate interests.
                    
                </p>
                <p>
                    With regard to the cases referred to in (1) and (3), the person responsible shall take appropriate measures to safeguard the rights and freedoms and your legitimate interests, including at least the right to obtain action by the person responsible, to state his or her own position and to challenge the decision.
                    
                </p>
                <p><b>10. Right to appeal to a supervisory authority</b></p>
                
                <p>
                    Without prejudice to any other administrative or judicial remedy, you have the right to appeal to a supervisory authority, in particular in the Member State where you are resident, at your workplace or at the place of the alleged infringement, if you consider that the processing of the personal data relating to you infringes the GDPR.
                    
                </p>
                <p>
                    The supervisory authority to which the complaint has been lodged shall inform the complainant of the state of play and the results of the complaint, including the possibility of legal remedy in accordance with Article 78 of the GDPR.
                    
                </p>
                <p><b>IV. Integration Of Third-Party Services And Content</b></p>
                
                <p>
                    Insofar as we integrate third party content on our website, such as videos from Youtube or content from other websites, the possibility to consume such content via our website presupposes that your IP address is transmitted to the providers of such content ("third party providers"). Otherwise, this content could not be sent to your browser. The IP address is therefore required for the presentation of this content. We make every effort to use only those contents whose respective providers use the IP address solely for sending the integrated contents. If a third party provider stores your IP address for other purposes, e. g. for statistical purposes, we have no influence on it and cannot provide you with any information in this regard due to a lack of knowledge.
                    
                </p>
                <p><b>V. Google Analytics</b></p>
                
                <p>
                    This website uses the functions of the web analytics service Google Analytics. Provider is Google Inc., 1600 Amphitheatre Parkway Mountain View, CA 94043, USA.
                    
                </p>
                <p>
                    Google Analytics uses so-called "cookies". These are text files that are stored on your computer and allow an analysis of your use of the website. The information generated by the cookie about your use of this website is usually transferred to a Google server in the USA and stored there.
                    
                </p>
                <p>
                    Google will use this information to evaluate your use of our website, to compile reports on website activity and to provide other services associated with the use of the website and the Internet. Google may also transfer this information to third parties if required by law or if third parties process this data on behalf of Google.
                    
                </p>
                <p>
                    For more information on how we handle user data at Google Analytics, please see the Google Privacy Policy: https://support.google.com/analytics/answer/6004245?hl=en
                    
                </p>
                <p>
                    You can prevent the storage of cookies by setting your browser software accordingly; however, we would like to point out that in this case you may not be able to use all the functions of this website in full. You can also prevent Google from collecting the data generated by the cookie and relating to your use of the website (including your IP address) and from processing this data by Google by downloading and installing the browser plugin available under the following link: https://tools.google.com/dlpage/gaoptout?hl=en
                    
                </p>
                <p>
                    <b>
                        Opposition to data collection
                        
                    </b>
                </p>
                
                <p>
                    You can prevent Google Analytics from collecting your information by clicking on the link below. An opt-out cookie is set to prevent your data from being collected when you visit this website in the future: disable Google Analytics
                    
                </p>
                <p>
                    Demographic features in Google Analytics
                    
                </p>
                <p>
                    This website uses the "demographic features" feature of Google Analytics. This allows reports to be created that contain information about the age, gender and interests of the visitors to the site. This data originates from Google's interest-based advertising and visitor data from third-party providers. This data cannot be assigned to a specific person. You can disable this feature at any time through your Google Account's ad settings, or disallow the collection of your information by Google Analytics as shown in the "Disclaimer" section.
                    
                </p>
                <p><b>VI. Facebook Social Plugins</b></p>
                
                <p>
                    Our website uses social plugins ("plugins") of the social network facebook. com, which is operated by Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland ("Facebook"). The list and the appearance of the Facebook social plugins can be viewed here: https://developers.facebook.com/docs/plugins/ .
                    
                </p>
                <p>
                    When you access a feature of our website that includes such a plugin, your device establishes a direct connection to Facebook's servers. The content of the plugin is transmitted by Facebook directly to the user's device and is integrated into the Internet offer by the user. User profiles can be created from the processed data. We have no control over the amount of data that Facebook collects using this plug-in and can therefore only provide you with information on our level of knowledge.
                    
                </p>
                <p>
                    By integrating the plugin, Facebook receives the information that a user has called up a corresponding page on our website. If you are logged in to Facebook, Facebook can associate your visit with your Facebook account. If you interact with the plugins, for example by clicking on the Like button or by making a comment, the corresponding information is sent directly from your device to Facebook and stored there. If you are not a Facebook member, there is still the possibility that Facebook will find out your IP address and save it. According to Facebook, only one anonymous IP address is stored in Germany.
                    
                </p>
                <p>
                    The scope and purpose of the data collection and the further processing and use of the data by Facebook, as well as the rights and options for privacy protection in this respect, can be found in Facebook's privacy policy: https://www.facebook.com/about/privacy .
                    
                </p>
                <p>
                    If you are a Facebook member and do not want Facebook to collect information about Sei through our website and link it to your Facebook-membership information, you must log out/log out and delete your cookies before using our websites. Further settings and inconsistencies regarding the use of data for advertising purposes can be made within the Facebook profile settings: https://www.facebook.com/settings?tab-ads or via the US-American site: http://www.aboutads.info/choices or the EU site: http://www.youronlinechoices.com . The settings are platform-independent, i. e. they are applied to all devices, such as desktop computers or mobile devices.
                    
                </p>
                <p><b>VII. Using The Twitter Buttons</b></p>
                
                <p>
                    Our website uses the buttons of the Twitter service, Twitter Inc., One Cumberland Place, Fenian Street, Dublin 2, D02 AX07, Ireland, recognizable by a stylized blue bird. With the help of the button it is possible to share a contribution or page of our offer on Twitter or to follow us on Twitter.
                    
                </p>
                <p>
                    When you access a page of our website that contains such a button, your browser establishes a direct connection with the servers of Twitter. Twitter sends the contents of the Twitter button directly to your browser. We have no influence on the amount of data that Twitter collects with the help of this plugin and will inform you according to our knowledge. Accordingly, only your IP address and the URL of the respective website will be transmitted with the button, but not used for purposes other than displaying the button.
                    
                </p>
                <p>
                    For more information, please see the Twitter Privacy Policy at: <a href="http://twitter.com/privacy" rel="noreferrer" target="_blank">http://twitter.com/privacy</a>.
                    
                </p>
                <p><b>VIII. Changes To The Privacy Policy</b></p>
                
                <p>
                    We reserve the right to amend the data protection declaration in order to adapt it to changed legal situations or in the event of changes to the service and data processing. However, this applies solely with regard to declarations on data processing. If your consent is required or if parts of the data protection declaration contain regulations of the contractual relationship with you, changes will only be made with your consent.
                    
                </p>
                <p>
                    You are asked to inform yourself regularly about the content of our data protection declaration.
                    
                </p>
                <p><b>IX. Name and address of the responsible body</b></p>
                
                <p>
                    The responsible body within the meaning of the EU General Data Protection Regulation and other national data protection laws of the EU member states as well as other data protection regulations is:
                    
                </p>
                <p>Email: : <a href="mailto:info@cryptoadsnft.com">info@cryptoadsnft.com </a><br/> Website: <a href="cryptoadsnft.com" target="_blank">cryptoadsnft.com</a></p>
                
                <p><b>PLEASE NOTE/ COMMENTS:</b></p>
                
                <p>
                    The above sample data protection declaration is to be understood as the basic framework for a data protection declaration for website operators conforming to the EU General Data Protection Regulation (GDPR). The declaration is not conclusive and does perhaps not include all necessary elements. This draft may also contain elements that are not used on Cryptoadsnfts‘s websites. It is therefore necessary to adapt and supplement the declaration.
                    
                </p>
                <p><b>Missing elements:</b></p>
                
                <p>
                    The following elements are not part of the data protection declaration. It must be checked whether Cryptoadsnft is responsible for its use. In this case, the declaration shall be extended accordingly. The type, scope, purpose, duration and revocation possibilities of data processing must be stated.
                    
                </p>
                <p><b>(1) Newsletter tracking</b></p>
                
                <p>
                    If the website uses a newsletter tracking system, the associated data processing must be dealt with separately. A justification standard for data processing will be found in Art. 6 para. 1 lit. f GDPR.
                    
                </p>
                <p><b>(2) Blog with comment function</b></p>
                
                <p>
                    When operating a blog with comment function, additional personal data (example: pseudonyms) are stored. There is also a possibility of subscribing to comments. Commenting should only be possible after obtaining consent to the processing of personal data. In this case, a justification according to Art. 6 para. 1 lit. a GDPR is possible.
                    
                </p>
                <p><b>(3) Conclusion of a contract</b></p>
                
                <p>
                    The personal data collected in the context of the conclusion of the contract shall be discussed in detail. The website operator has to point out this data processing separately and in detail. Insofar as the processing of data is necessary for the conclusion of the contract, Art. 6 para. 1 lit. b of the GDPR serves as a standard for data processing.
                    
                </p>
                <p><b>(4) Passing on of personal data</b></p>
                
                <p>
                    Many websites use third-party extensions. In such implementations, personal data is often passed on to third parties or transmitted automatically. The type, scope, purpose and duration of this processing of personal data may differ from case to case. A comprehensive list of all situations in which personal data is passed on to third parties would go beyond the scope of this draft of the data protection declaration. Therefore, we have to check which third party services you are really using on the website and whether personal data is passed on.
                    
                </p>
                <p>
                    <b>The above-mentioned third party services (social media & google service) require further discussion.</b>
                    
                </p>
                <p>
                    Examples of the passing on of personal data to third parties may be:
                    
                </p>
                <p><b>a) Disclosure to service providers</b></p>
         
                <p>
                    Personal data is often passed on to service providers (e. g. suppliers) within the framework of contracts concluded via the website. However, service providers can also act in the sole interest of the website operator (e. g. technical service).
                    
                </p>
                <p><b>b) Payment services and payment procedures</b></p>
                
                <p>
                    A special case of the passing on to service providers is the passing on of data to payment services.
                    
                </p>
                <p><b>c) Third party cookies</b></p>
                
                <p>
                    The integration of your own cookies is part of the draft. Often third party cookies are also used. These shall be described in detail. Users must be informed of the use of third party cookies when accessing the website. A way to prevent these cookies from being stored can be found in the browser settings. The legal basis for the use of third party cookies is Art. 6 para. 1 lit. f GDPR. In this case, however, a legitimate interest for the use of the cookie must also be stated.
                    
                </p>
                <p>
                    d) Advertising and marketing services
                    
                </p>
                <p>
                    If advertisements are placed on the website, this usually takes place with the inclusion of third-party providers (e. g. Google AdSense or AdWords). Usually, personal data of the users is passed on to the intermediaries in the form of the IP address. If advertising is required to finance the website, a justification in accordance with Art. 6 para. 1 lit. f of the GDPR appears to be possible.
                    
                </p>
                <p>
                    <b>Data protection impact assessment, Art. 35 GDPR</b>
                    
                </p>
                <p>
                    1. where a form of processing, in particular where new technologies are used, is likely to entail a high risk to the rights and freedoms of natural persons as a result of the nature, scope, circumstances and purposes of processing, the controller shall carry out an advance assessment of the consequences of the processing operations envisaged for the protection of personal data. A single estimate can be made for the investigation of several similar processing operations with similarly high risks.
                    
                </p>
                <p>
                    2. the person responsible shall seek the advice of the Data Protection Officer, if any, when carrying out a Data Protection Impact Assessment.
                    
                </p>
                <p>
                    3. a data protection impact assessment pursuant to paragraph 1 shall be required in particular in the following cases:
                    
                </p>
                <p>
                    (a) systematic and comprehensive assessment of the personal aspects of natural persons based on automated processing, including profiling, which in turn serves as a basis for decisions which have legal effect on natural persons or which have a similarly significant impact on them;
                    
                </p>
                <p>
                    (b) extensive processing of specific categories of personal data referred to in Article 9 (1) or of personal data relating to criminal convictions and offences referred to in Article 10; or
                    
                </p>
                <p>
                    (c) systematic and comprehensive monitoring of publicly accessible areas;
                    
                </p>
                <p>
                    4. The supervisory authority shall draw up and publish a list of the processing operations for which a data protection impact assessment shall be carried out in accordance with paragraph 1. The supervisory authority shall forward these lists to the Committee referred to in Article 68.
                    
                </p>
                <p>
                    5. The Supervisory Authority may also establish and publish a list of the types of processing operations for which no data protection impact assessment is required. The Supervisory Authority shall forward these lists to the Committee.
                    
                </p>
                <p>
                    6. before establishing the lists referred to in paragraphs 4 and 5, the competent supervisory authority shall apply the coherence procedure referred to in Article 63 where such lists include processing activities which are connected with the supply of goods or services to, or observation of the behaviour of, data subjects in several Member States or which could significantly affect the free movement of personal data within the Union.
                    
                </p>
                <p>
                    The impact assessment shall include at least the following:
                    
                </p>
                <p>
                    (a) a systematic description of the processing operations envisaged and the processing purposes, including where appropriate the legitimate interests pursued by the controller, and
                    
                </p>
                <p>
                    (b) an assessment of the necessity and proportionality of processing operations with regard to their purpose;
                    
                </p>
                <p>
                    (c) an assessment of the risks to the rights and freedoms of the persons concerned in accordance with paragraph 1; and
                    
                </p>
                
                <p>(d) the remedial measures envisaged to mitigate the risks, including guarantees, safeguards and procedures to ensure the protection of personal data and to demonstrate that this Regulation is being complied with, taking into account the rights and legitimate interests of data subjects and other interested parties.</p>              <p>
                    8. due account shall be taken of compliance by the competent processor (s) with approved rules of conduct referred to in Article 40 when assessing the effects of the processing operations carried out by them, in particular for the purposes of a data protection impact assessment.
                    
                </p>
                <p>
                    9. where appropriate, the controller shall seek the views of the data subjects or their representatives on the intended processing, without prejudice to the protection of industrial or public interests or the safety of processing operations.
                    
                </p>
                <p>
                    10. where the processing referred to in Article 6 (1)(c) or (e) is based on a legal basis laid down in Union law or in the law of the Member State to which the person responsible is subject and where that legislation governs the specific processing operation or operations and a data protection impact assessment has already been carried out within the framework of the general impact assessment in connection with the adoption of that legal basis, paragraphs 1 to 7 shall apply only where it is at the discretion of the Member States that such an impact assessment should be carried out before the processing activities concerned.
                    
                </p>
                <p>
                    11. where necessary, the controller shall carry out a review to assess whether processing is carried out in accordance with the data protection impact assessment, at least if changes have occurred in relation to the risks associated with the processing operations.
                    
                </p>
                <p>
                    <b>Previous consultation, Art. 36 GDPR</b>
                    
                </p>
                <p>
                    1. the controller shall consult the supervisory authority prior to processing where a data protection impact assessment in accordance with Article 35 indicates that processing would entail a high risk, unless the controller takes measures to mitigate the risk.
                    
                </p>
                <p>
                    2. if the supervisory authority considers that the envisaged processing referred to in paragraph 1 is not in conformity with this Regulation, in particular because the controller has not sufficiently identified or contained the risk, it shall make appropriate written recommendations to the controller and, where appropriate, to the processor within a period of up to eight weeks after receipt of the request for consultation and may exercise its powers referred to in Article 58. Taking into account the complexity of the planned processing, this deadline may be extended by six weeks. The supervisory authority shall inform the person responsible or, where appropriate, the processor of such an extension of time within one month of receipt of the request for consultation, together with the reasons for the delay. These deadlines may be suspended until the supervisory authority has received the information requested for the purposes of consultation.
                    
                </p>
                <p>
                    3. the person responsible shall make the following information available to the supervisory authority during a consultation as referred to in paragraph 1:
                    
                </p>
                <p>
                    (a) where appropriate, details of the responsibilities of the controller, the jointly responsible parties and the processors involved in processing, in particular where processing takes place within a group of undertakings;
                    
                </p>
                <p>
                    (b) the purposes and means of the intended processing;
                    
                </p>
                <p>
                    (c) the measures and safeguards provided for in this Regulation to protect the rights and freedoms of the persons concerned;
                    
                </p>
                <p>
                    (d) where appropriate, the contact details of the Data Protection Officer;
                    
                </p>
                <p>
                    (e) the data protection impact assessment referred to in Article 35; and
                    
                </p>
                <p>
                    (f) any other information requested by the supervisory authority
                    
                </p>
                <p>
                    4. Member States shall consult the supervisory authority in preparing a proposal for legislative measures to be adopted by a national parliament or for regulatory measures based on such legislative measures relating to processing.
                    
                </p>
                <p>
                    5. Notwithstanding paragraph 1, the right of Member States may oblige those responsible to consult the supervisory authority and obtain its prior authorisation when processing for the performance of a task in the public interest, including processing for social security and public health purposes.
                    
                </p>
                <p>
                    <b>Appointment of a data protection officer</b>
                    
                </p>
                <p>
                    1. the person responsible and the processor shall in any case appoint a data protection officer if:
                    
                </p>
                <p>
                    (a) processing is carried out by an authority or public body, with the exception of courts acting in the course of their judicial activities,
                    
                </p>
                <p>
                    (b) the core activity of the controller or processor consists of carrying out processing operations which, by reason of their nature, scope and/or purpose, require extensive regular and systematic monitoring of the persons concerned; or
                    
                </p>
                <p>
                    (c) the core activity of the controller or processor is the extensive processing of specific categories of data referred to in Article 9 or of personal data on criminal convictions and offences referred to in Article 10.
                    
                </p>
                <p>
                    2. A group of companies may appoint a joint data protection officer, provided that the data protection officer can be easily reached from each branch office.
                    
                </p>
                <p>
                    3. where the controller or processor is an authority or public body, a common data protection officer may be appointed for several such authorities or bodies, taking into account their organisational structure and size.
                    
                </p>
                <p>
                    4. in cases other than those referred to in paragraph 1, the controller or processors or associations or associations and other associations representing the categories of controllers or processors may appoint a data protection officer; if required by Union or Member State law, they must designate such an officer. The Data Protection Officer may act on behalf of such associations and other associations representing those responsible or contractors.
                    
                </p>
                <p>
                    5. the Data Protection Officer shall be appointed on the basis of his professional qualifications and, in particular, the expertise he possesses in the field of data protection law and practice, as well as on the basis of his ability to perform the tasks referred to in Article 39.
                    
                </p>
                <p>6. the data protection officer may be an employee of the person responsible or of the data processor or may perform his duties on the basis of a service contract.</p>

                <p>7. the data controller or processor shall publish the contact details of the data protection officer and communicate this data to the supervisory authority.</p>



        </div>
    );
}

export default Privacy;